import { isFocusEnv, FocusSDK } from ".";

export default function getAppEntry() {
  // 本地开发环境
  if (process.env.NODE_ENV !== "production") {
    return `http://desktop.jdcloud.com:${window.location.port}`;
  }
  // webapp测试环境
  if (process.env.REACT_APP_ROUTE_BASE?.includes("webapp-test")) {
    return process.env.PUBLIC_URL;
  }

  let url = "";
  if (isFocusEnv()) {
    const urls = FocusSDK.getInnerAppPreloadJSPath().split("/");
    urls.pop();
    url = urls.join("/");
    url = `${url}/resources/webapp_build`;
  } else {
    // const publicUrl = process.env.PUBLIC_URL.split("/");
    // publicUrl.pop();
    // url = publicUrl.join("/");
    return process.env.PUBLIC_URL
  }
  return url;
}
